import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    buckets: string;
};
export const schemaLoanRequestResolver_GetCountByBuckets = z.number();

export type SchemaLoanRequestResolver_GetCountByBuckets = z.infer<typeof schemaLoanRequestResolver_GetCountByBuckets>;

export type LoanRequestResolver_GetCountByBuckets = Resolver<Arguments, SchemaLoanRequestResolver_GetCountByBuckets>;
